import { autobind } from 'core-decorators';
import { Component } from 'react';

import ControlApplications from '/@/components/control-applications';
import { _, _lazy } from '/@/locale';
import styles from './styles.module.css';

@autobind
export default class CornDiseaseControl extends Component {
    static label = _lazy('Manejo de enfermedades');
    static icon = 'disease';

    render() {
        const profiles = this.props.productRecommendations.map(({ profile }) => profile);
        return <div className={styles.root}>{profiles.map(this.renderProfile)}</div>;
    }

    renderProfile(profile) {
        if (profile.diseases.length === 0) return null;
        return (
            <div key={profile.id} className={styles.profile}>
                <div className={styles.title}>{_(profile.label)}</div>
                <div className={styles.diseases}>{this.renderProfileDiseaseApplication(profile.diseases)}</div>
            </div>
        );
    }

    renderProfileDiseaseApplication(applications) {
        const windowKeys = [];
        const windows = {};

        applications.forEach((application) => {
            const key = `${application.windowStart}-${application.windowEnd}`;
            if (!windowKeys.includes(key)) {
                windowKeys.push(key);
                windows[key] = {
                    index: windowKeys.length,
                    start: application.windowStart,
                    end: application.windowEnd,
                    products: [],
                };
            }
            windows?.[key]?.products.push({
                index: windows?.[key]?.products.length + 1,
                name: _(application.product),
                dose: application.dose,
                unit: _(application.doseUnit),
                order: application.order,
            });
        });

        const getWindowTitle = ({ start, end }) => {
            if (start === end) return _('{{start}}', { start });
            return _('{{start}} - {{end}}', { start, end });
        };

        return (
            <ControlApplications
                data={windowKeys.map((windowKey) => ({
                    windows: [
                        {
                            title: getWindowTitle(windows[windowKey]),
                            items: windows?.[windowKey]?.products
                                .sort((a, b) => b.order - a.order)
                                .map((product) => {
                                    return (
                                        <div>
                                            <strong>{product.name}</strong>
                                            <br />
                                            {product.dose} {product.unit}
                                        </div>
                                    );
                                }),
                        },
                    ],
                }))}
            />
        );
    }
}
